module.exports = __webpack_public_path__ + "5abcd2e65c3fb5e3fdeb3647ed05d408.jpg";